import React from 'react';

/**
 * Status pill. Variants are semantic only — there is deliberately no "purple"
 * or "indigo", because a colour here has to tell the reader what state
 * something is in, not which category it belongs to.
 */

const VARIANTS = {
  neutral: 'bg-neutral-soft text-neutral-fg border-border',
  success: 'bg-success-soft text-success-fg border-success/20',
  warning: 'bg-warning-soft text-warning-fg border-warning/20',
  danger: 'bg-danger-soft text-danger-fg border-danger/20',
  info: 'bg-info-soft text-info-fg border-info/20',
  /* Solid navy — used for the work-order type (PPM / SR), which is an
     identifier rather than a status. */
  type: 'bg-primary text-primary-fg border-primary',
};

const SIZES = {
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-2.5 py-1 text-xs',
};

const Badge = ({ variant = 'neutral', size = 'md', dot = false, className = '', children }) => (
  <span
    className={[
      'inline-flex items-center gap-1.5 whitespace-nowrap rounded-sm border font-medium',
      VARIANTS[variant] || VARIANTS.neutral,
      SIZES[size] || SIZES.md,
      className,
    ].join(' ')}
  >
    {/* The dot repeats the status without relying on colour alone. */}
    {dot && <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-current" aria-hidden="true" />}
    {children}
  </span>
);

/**
 * Maps a free-text QDF status string onto a semantic variant.
 * Kept here so every screen renders the same status the same way.
 */
export const statusVariant = (status) => {
  const s = (status || '').toLowerCase();
  if (s.includes('completed') || s.includes('closed complete')) return 'success';
  if (s.includes('closed') || s.includes('cancel')) return 'danger';
  if (s.includes('hold')) return 'warning';
  if (s.includes('active') || s.includes('progress') || s.includes('open')) return 'info';
  return 'neutral';
};

export default Badge;
